import React from 'react';
import WarningModal from 'components/WarningModal/WarningModal';
import {useForm} from 'react-hook-form';
import {ErrorMessage} from '@hookform/error-message';

import styles from './CampaignModalInputs.module.scss';
import {useAddCampaignMutation} from 'store/slices/campaignSlice';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function CreateCampaignModal({open, onClose}: Props) {
  const [createCampaign, {isLoading}] = useAddCampaignMutation();

  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm({
    defaultValues: {name: '', link: '', imageUrl: ''},
  });

  const onSubmit = async (data: any) => {
    await createCampaign(data);
    reset();
    onClose();
  };

  if (!open) return null;

  return (
    <WarningModal
      isOpen={open}
      onClose={onClose}
      entityText=""
      title="Create new campaign"
      textBlocks={[]}
      confirmButtonText="Create"
      onConfirmButtonClick={handleSubmit(onSubmit)}
      loading={isLoading}
    >
      <div className={styles.inputContainer}>
        <label>Name</label>
        <input
          {...register('name', {required: 'Name is required'})}
          className={`${styles.input} ${errors?.name ? styles.inputError : ''}`}
        />
        <ErrorMessage
          errors={errors}
          name="name"
          render={({message}) => (
            <span className={styles.inputErrorMessage}>{message}</span>
          )}
        />
      </div>

      <div className={styles.inputContainer}>
        <label>Link</label>
        <input
          {...register('link', {required: 'Link is required'})}
          className={`${styles.input} ${errors?.link ? styles.inputError : ''}`}
        />
        <ErrorMessage
          errors={errors}
          name="link"
          render={({message}) => (
            <span className={styles.inputErrorMessage}>{message}</span>
          )}
        />
      </div>

      <div className={styles.inputContainer}>
        <label>Image URL</label>
        <input {...register('imageUrl')} className={styles.input} />
        <ErrorMessage
          errors={errors}
          name="imageUrl"
          render={({message}) => (
            <span className={styles.inputErrorMessage}>{message}</span>
          )}
        />
      </div>
    </WarningModal>
  );
}
